import React, { Fragment } from 'react';
import { Field } from 'react-final-form';


function OperatorsSelect() {

    return (
        <Field
            name="listOperators"
            component="select"
            className="form-control form-control-alternative"
        >
            <option value="">Todos</option>
            <option key="Nenhum" value="Nenhum" >Nenhum</option>
        </Field>
    );
}

export default OperatorsSelect;



// WEBPACK FOOTER //
// ./src/components/Pages/CommissionsTransfers/Filters/OperatorsSelect.js